import { render, staticRenderFns } from "./InformacionTratamiento.vue?vue&type=template&id=2a55be14&scoped=true"
import script from "./InformacionTratamiento.vue?vue&type=script&lang=js"
export * from "./InformacionTratamiento.vue?vue&type=script&lang=js"
import style0 from "./InformacionTratamiento.vue?vue&type=style&index=0&id=2a55be14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a55be14",
  null
  
)

export default component.exports